import { render } from "./RuntimeRef.vue?vue&type=template&id=3e5970ab&scoped=true"
import script from "./RuntimeRef.vue?vue&type=script&lang=js"
export * from "./RuntimeRef.vue?vue&type=script&lang=js"

import "./RuntimeRef.vue?vue&type=style&index=0&id=3e5970ab&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/lemmi_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e5970ab"]])

export default __exports__